import invalidateCanvasGraph from '@/hooks/canvas/helpers/invalidateCanvasGraph';
import coerceToRecord from '../helpers/coerceToRecord';
import eventMatchesToolNames from '../helpers/eventMatchesToolNames';
import getStringValue from '../helpers/getStringValue';
import type {
    BuildRefetchCanvasOnItemCreateSubscriptionParams,
    ChatEffectSubscription,
} from '../types';

const CANVAS_ITEM_CREATE_TOOL_NAMES = [
    'create_canvas_item',
    'canvases.createItem',
    'import_canvas_item_from_url',
    'canvases.importItemFromUrl',
    'create_visual_identity_from_url',
    'canvases.createVisualIdentity',
];

const buildRefetchCanvasOnItemCreateSubscription = (
    _params: BuildRefetchCanvasOnItemCreateSubscriptionParams
): ChatEffectSubscription => {
    return {
        id: 'refetch-canvas-on-item-create',
        routePattern: '/agents/:agentId/canvas/:canvasId',
        eventType: 'TOOL_CALL_RESULT',
        filter: ({ event, matchParams }) => {
            if (
                !eventMatchesToolNames({
                    event,
                    toolNames: CANVAS_ITEM_CREATE_TOOL_NAMES,
                })
            ) {
                return false;
            }

            const args = coerceToRecord({ value: event.args });
            const canvasIdFromArgs = getStringValue({ value: args.canvasId });

            if (!canvasIdFromArgs) {
                return true;
            }

            return canvasIdFromArgs === matchParams.canvasId;
        },
        action: ({ queryClient, matchParams }) => {
            invalidateCanvasGraph({
                queryClient,
                organizationId: matchParams.agentId,
                canvasId: matchParams.canvasId,
            });
        },
    };
};

export default buildRefetchCanvasOnItemCreateSubscription;
